import React, {useEffect, useState} from "react";
import {Box} from "@mui/material";
import ResolvedModal from "./components/resolvedModal";
import ResolvedDrawer from "./components/resolvedDrawer";
import {useNavigate, useParams, useSearchParams} from "react-router";
import {useDispatch, useSelector} from "react-redux";
import {AppDispatch, RootState} from "@store/store.tsx";
import {
    fetchTicketDetailsById,
    updateTicketStatus,
} from "@store/ticketListSlice.tsx";
import AddUserModal from "@common/components/AddUser/addUserModal";
import {clearMessages, fetchMessages, setAttachments} from "@store/chatSlice.tsx";
import Conversation from "./components/conversation";
import ChatInputSection from "./components/chatInputSection";
import ChatHeader from "./components/chatHeader";

const Chat: React.FC = () => {
    const [resolvedDrawer, setResolvedDrawer] = useState<boolean>(false);
    const [addUserModal, setAddUserModal] = useState<boolean>(false);
    const navigate = useNavigate();
    const dispatch = useDispatch<AppDispatch>();
    const {id} = useParams();
    const [initialLoader, setInitialLoader] = useState(true);
    const [customStatus, setCustomStatus] = useState<string>("");
    const {ticketDetails} = useSelector((state: RootState) => state.tickets);
    const { customStatuses } = useSelector((state: RootState) => state.config);
    const currentTicketId = ticketDetails?.request?.id; 

    const [searchParams] = useSearchParams();
    const status = searchParams.get("status");

    useEffect(() => {
        if (id && id !== "new") {
            dispatch(fetchMessages({ticketId: Number(id), page: 1}));
        } else {
            dispatch(clearMessages());
        }
        dispatch(setAttachments([]));
    }, []);
    useEffect(() => {
        if (id && id !== "new") {
            dispatch(fetchTicketDetailsById({id}));
        }
    }, [id]);
    const handleTicketResolvedAction = () => {
        if (ticketDetails?.request) {
            let tags:string="";
            if(ticketDetails?.request?.subject==="LIVE PERFUSION"){
                tags="live_perfusion";
            }
            if(ticketDetails?.request?.subject==="POST PERFUSION"){
                tags="post_perfusion";
            }
            if(ticketDetails?.request?.subject==="GENERAL"){
                tags="general";
            }
           const customStatus = customStatuses.find((status)=> status.endUserLabel === "Resolved");
            let tagValue = "general";
            if (tags?.includes("live_perfusion")) {
                tagValue = "live_perfusion";
            } else if (ticketDetails.request.subject.includes("post_perfusion")) {
                tagValue = "post_perfusion";
            }

            const payload = {
                customTicketStatusId: customStatus?.id,
                tag: tagValue,
                statusName:"solved",
            };
            dispatch(
                updateTicketStatus({
                    ticketId: ticketDetails?.request?.id,
                    payload,
                })
            );
            setResolvedDrawer(false);
        }
    };

    const handleBackClick = () => {
        if(status){
            navigate(-1);
        }else{
            navigate("/");
        }
    };

    return (
        <>
            <ChatHeader
                ticketId={id}
                onBackClick={handleBackClick}
                setResolvedDrawer={setResolvedDrawer}
                status={status}
                setCustomStatus={setCustomStatus}
                customStatus={customStatus}
                id={id}/>
            <Box
                 className="md:px-8"
                 sx={{
                     display: "flex",
                     flexDirection: "column",
                     width: "100%",
                     height: "calc(100vh - 165px)",
                     justifyContent: "space-between",
                 }}
             >
                <Conversation
                    setInitialLoader={setInitialLoader}
                    initialLoader={initialLoader}
                />{status !== "closed" && (
                <ChatInputSection setAddUserModal={setAddUserModal} customStatus={customStatus}/>)}
                <ResolvedModal
                    resolvedDrawer={resolvedDrawer}
                    setResolvedDrawer={setResolvedDrawer}
                    handleTicketResolvedAction={handleTicketResolvedAction}
                />
                <ResolvedDrawer
                    resolvedDrawer={resolvedDrawer}
                    setResolvedDrawer={setResolvedDrawer}
                    handleTicketResolvedAction={handleTicketResolvedAction}
                />
                <AddUserModal
                    addUserModal={addUserModal}
                    setAddUserModal={setAddUserModal}
                    ticketId={currentTicketId}      // Pass the ticket ID
                />
            </Box>
        </>
    );
};
export default Chat;